module.exports = __webpack_public_path__ + "img/628f1765e9375a5f191cae2d4310b195.png";